module.exports = "https://cdn-social.hiplatform.com/images/ae89425b562191ae40d99184fe6cfb52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/disappointed.svg
// module id = QXcB
// module chunks = 0